import * as Sentry from '@sentry/remix';


export const setSentryUser = (userInfo) => {
  Sentry.setUser({
    student_id: userInfo.studentId,
    Student_firstName: userInfo.firstName,
    Student_lastName: userInfo.lastName,
    School_id: userInfo.schoolId,
    loginuserid: userInfo.loginUserId
  });
};

export const setSentryExtras = (extras = {}) => {
    Object.entries(extras).forEach(([key, value]) => {
      Sentry.setExtra(key, value);
    });
  };

  export const sendCustomEvent = (message, level, extra = {}, fingerprint = []) => {
    
    Sentry.withScope((scope) => {
      // Object.entries(tags).forEach(([key, value]) => scope.setTag(key, value));
      Object.entries(extra).forEach(([key, value]) => {
        Sentry.setExtra(key, value);
      });
  
      Sentry.captureEvent({
        message,
        level,
        extra,
        fingerprint
      });
    });
  };

  export const sendScopedException = (error, fingerprint = [], tags = {}, extras = {}) => {
    
    Sentry.withScope((scope) => {
      if (fingerprint.length > 0) {
        scope.setFingerprint(fingerprint);
      }
  
      Object.entries(tags).forEach(([key, value]) => {
        scope.setTag(key, value);
      });
  
      Object.entries(extras).forEach(([key, value]) => {
        Sentry.setExtra(key, value);
      });
  
      Sentry.captureException(error);
    });
  };
  
